<p-confirm-dialog [draggable]="false" />
<mon-page-layout
    [header]="'adminApiTokens.page.header' | transloco"
    [subheader]="'adminApiTokens.page.subHeader' | transloco">
    <mon-table-wrapper
            [value]="apiTokens"
            [headers]="[
                TABLE_SCHEMA.API_URL,
                TABLE_SCHEMA.DESCRIPTION,
                TABLE_SCHEMA.SCOPES,
                TABLE_SCHEMA.TOKEN,
                TABLE_SCHEMA.ACTIONS
            ]"
            [total]="total"
            [currentPage]="currentPage"
            [perPage]="perPage"
            [loading]="loading"
            [fixedTableLayout]="false"
            [emptyMessage]="'adminApiTokens.table.emptyMessage' | transloco"
            (page)="onPageChange($event)"
            tableKey="admin-apiTokens"
            data-test="admin-apiTokens-table">
        <ng-container monTableRight>
            <p-button data-test="admin-apiTokens-add-button"
                      [label]="'adminApiTokens.page.addButtonLabel' | transloco"
                      icon="pi pi-plus"
                      (click)="addApiToken()" />
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.API_URL; let apiToken">
            <span data-test="admin-apiTokens-apiPath-tableCell">{{ apiPath }}</span>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.TOKEN; let apiToken">
            <span class="api-token-cell-content" data-test="admin-apiTokens-token-tableCell">
                <mon-copy-to-clipboard-button
                        [textToCopy]="apiToken.token"
                        [tooltipText]="'adminApiTokens.table.copyToClipboardButton.tooltip' | transloco"
                        [ariaLabel]="'adminApiTokens.table.copyToClipboardButton.ariaLabel' | transloco"
                        [successMessage]="'adminApiTokens.table.copyToClipboardButton.successToast' | transloco"
                        trackingAction="admin-apiTokens-copy-token-button"
                />
                {{ apiToken.token }}
            </span>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTIONS; let apiToken">
            <p-button
                    [ariaLabel]="'adminApiTokens.table.actionMenuBtn.ariaLabel{{description}}' | transloco:{description: apiToken.description}"
                    data-test="admin-apiTokens-actions-button"
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="menu.toggle($event)"
            />
            <p-menu
                    data-test="admin-users-actions-menu"
                    appendTo="body"
                    #menu
                    [model]="apiToken.actionItems"
                    [popup]="true"
                    (onHide)="onMenuHide()"
            />
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
